module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "removeimg"
  }, [_vm._v("\n  " + _vm._s(_vm.status) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fd9f7e74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/removeimg/component.vue
// module id = 4019
// module chunks = 1